import BaseApi from './base/BaseApi';
import { PutOperation, GetOperation } from './base/operations';

export default class TaskApi extends BaseApi {
  static entityName = 'tasks';

  publish(id, withPreloader = true) {
    const operation = new PutOperation(`/api/tasks/${id}/publish`, []);
    return this.execute(operation, withPreloader);
  }

  fetchDraft(stageId, withPreloader = true) {
    const operation = new GetOperation(`/api/stage/${stageId}/task/draft`, []);
    return this.execute(operation, withPreloader);
  }
}
